import styled from 'styled-components'

export const MapMarkerWrapper = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    width: 1px;
    height: 1px;
`

export const IconWrapper = styled.div`
    position: absolute;
    margin-top: -32px;
`

export const Title = styled.div<{ $highlight: boolean }>`
    margin-top: 2px;
    position: absolute;
    padding: 0px 8px;
    border-radius: 11px;
    white-space: nowrap;
    color: ${(props) => (props.$highlight ? props.theme.color.white : props.theme.color.black)};
    background-color: ${(props) => (props.$highlight ? props.theme.color.a500 : props.theme.color.white)};
    ${(props) => props.theme.typo.bodyS};
    ${(props) => props.theme.fontWeight.medium}
    ${(props) => props.theme.boxShadow.level3}
`
